import React, { PureComponent } from 'react';
import { Table, Icon, Typography, Avatar } from 'antd';
import { withRouter } from 'react-router-dom';
import TablePageSize from '../../../../../common/components/TablePageSize';
import transport from '../../../../../common/images/svg/Transport.svg'

import './VehiclesTable.css';
import moment from 'moment';
import { API } from '../../../../../common/api/constants';
const IMAGE = API.replace('/api', '');

let tablePlaceholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;
const { Text } = Typography;
/* const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      'selectedRows: ',
      selectedRows
    );
  },
};*/

class VehiclesTable extends PureComponent {
  constructor(props) {
    super(props);
    let tableColumnsLen = Object.values(props.columns).filter(
      val => val === true
    ).length;

    this.state = {
      tableColumnsLen,
    };
  }

  static getDerivedStateFromProps(nextProps, state) {
    let { columns } = nextProps;

    let tableColumnsLen = Object.values(columns).filter(val => val === true)
      .length;

    if (state.tableColumnsLen !== tableColumnsLen) {
      state = {
        tableColumnsLen,
      };
    }

    return state;
  }

  // componentDidUpdate(_prevProps, prevState) {}
  ARHIVE_COLUMN = {
    title: 'Дата архивирования',
    dataIndex: 'dateArchive',
    key: 'dateArchive',
    render: data => (
      <span id="columnHeader">{data && moment(data).format('DD.MM.YYYY')}</span>
    ),
    sorter: (a, b) => {
      return a.dateArchive.localeCompare(b.dateArchive);
    },
  };

  renderColumns = () => {
    let { columns, marks } = this.props;
    let filteredCols = [
      {
        title: 'Наименование',
        dataIndex: 'vehicle',
        key: 'title',
        render: vehicle => (
          <div className="photoColumn">
            <Avatar
              shape="square"
              size="large"
              src={vehicle.photo ? `${IMAGE}${vehicle.photo}` : transport}
            />
            <span id="columnHeader">
              {vehicle.brand && vehicle.brand}
              <br />
              <Text type="secondary">{vehicle.model && vehicle.model}</Text>
            </span>
          </div>
        ),
        sorter: (a, b) => {
          return a.vehicle.model.localeCompare(b.vehicle.model);
        },
      },
    ];

    let cols = [
      {
        title: 'Год',
        dataIndex: 'year',
        key: 'productionYear',
        render: year => <span id="columnHeader">{year && year}</span>,
        sorter: (a, b) => {
          return a.year.localeCompare(b.year);
        },
      },
      {
        title: 'Рег. знак',
        dataIndex: 'registerSignAndRegion',
        key: 'registerSignAndRegion',
        render: registerSignAndRegion =>
          registerSignAndRegion ? (
            <span id="columnHeader">{registerSignAndRegion}</span>
          ) : (
            '3'
          ),
        sorter: (a, b) => {
          return a.registerSignAndRegion.localeCompare(b.registerSignAndRegion);
        },
      },
      {
        title: 'Мест',
        dataIndex: 'passengerCapacity',
        key: 'passengerCapacity',
        render: places => <span id="columnHeader">{places && places}</span>,
        sorter: (a, b) => {
          return a.passengerCapacity - b.passengerCapacity;
        },
      },
      {
        title: 'Цвет',
        dataIndex: 'color',
        key: 'colorName',
        render: color => <span id="columnHeader">{color && color}</span>,
        sorter: (a, b) => {
          return a.color.localeCompare(b.color);
        },
      },
      {
        title: 'Срок окончания диаг. карты',
        dataIndex: 'diagnosticCard',
        key: 'diagnosticCard',
        render: data => (
          <span id="columnHeader">
            {data && moment(data).format('DD.MM.YYYY')}
          </span>
        ),
        sorter: (a, b) => {
          return a.diagnosticCard.localeCompare(b.diagnosticCard);
        },
      },
      {
        title: 'Срок окончания полиса Каско',
        dataIndex: 'kaskoValidUntil',
        key: 'kaskoValidUntil',
        render: data => (
          <span id="columnHeader">
            {data && moment(data).format('DD.MM.YYYY')}
          </span>
        ),
        sorter: (a, b) => {
          return a.diagnosticCard.localeCompare(b.diagnosticCard);
        },
      },
      {
        title: 'Срок окончания полиса Осгопп',
        dataIndex: 'osgoppValidUntil',
        key: 'osgoppValidUntil',
        render: data => (
          <span id="columnHeader">
            {data && moment(data).format('DD.MM.YYYY')}
          </span>
        ),
        sorter: (a, b) => {
          return a.diagnosticCard.localeCompare(b.diagnosticCard);
        },
      },
      {
        title: 'Ставка',
        dataIndex: 'rate',
        key: 'rate',
        render: rate => (
          <span id="columnHeader">
            {rate && rate}
            <br />
            <Text type="secondary">{rate && rate}</Text>
          </span>
        ),
        sorter: (a, b) => {
          return a.rate.localeCompare(b.rate);
        },
      },
      {
        title: 'Исполнители',
        dataIndex: 'executors',
        key: 'executors',
        render: executor => (
          <span id="columnHeader">{executor && executor}</span>
        ),
        sorter: (a, b) => {
          return a.executor.localeCompare(b.executor);
        },
      },

      // {
      //     title: 'Дата ближ. подачи',
      //     dataIndex: 'date',
      //     key: 'date',
      //     width: '10%',
      //     render: date => (
      //         <span id="columnHeader">{date[0] && date[0]}<br />
      //             <Text type="secondary">{date[1] && date[1]}</Text></span>
      //     ),
      //     sorter: (a, b) => { return a.date[0].localeCompare(b.date[0]) },
      // },
      // {
      //     title: 'Подходящие заказы',
      //     dataIndex: 'orders',
      //     key: 'orders',
      //     width: '15%',
      //     render: orders => (
      //         <span id="columnHeader">
      //             {orders.filter((_order, index) => index < 4).map(order =>
      //                 (`${order} `)
      //             )}<br />
      //             <Text type="secondary">
      //                 {(orders.length && orders.length > 4) ?
      //                     `И ещё ${orders.length - 4} Заказов` :
      //                     ''}
      //             </Text>
      //         </span>
      //     ),
      //     sorter: (a, b) => { return a.orders.length - b.orders.length },
      // },
    ];
    /* Фильтр столбцов таблицы по выбранным чекбоксам - value объекта columns (true/false) */
    for (let [key, value] of Object.entries(columns)) {
      cols.forEach(col =>
        col.key === key && value === true ? filteredCols.push(col) : null
      );
    }

    marks.includeStatusKey === 'status_key[]=archive' &&
      filteredCols.push(this.ARHIVE_COLUMN);
    // console.log('FILTERED', filteredCols);

    return filteredCols;
  };

  // попадаем в карточку ТС
  getVehicleById = id => this.props.history.push(`/vehicle_card/${id}`);

  renderTable = () => {
    let { vehicles } = this.props;
    return vehicles;
  };
  render() {
    let { tableColumnsLen } = this.state;
    let { pages, isLoading, changePaginationSize } = this.props;
    const columns = this.renderColumns();
    const vehicles = this.renderTable();
    /*const emptyText = {
      emptyText: filtersStatus
        ? 'По вашему запросу ни чего нет'
        : vehicles.length === 0
        ? tablePlaceholder
        : 'Тех. средств пока нету',
    };*/
    return (
      <div className="vehiclesTable">
        <Table
          onRow={(record, index) => ({
            index,
            onClick: () => this.getVehicleById(record.vehicle.id),
          })}
          locale={{
            emptyText: isLoading ? tablePlaceholder : 'Тех. средств нет',
          }}
          columns={columns}
          dataSource={vehicles}
          // rowSelection={rowSelection}
          pagination={{
            pageSize: pages,
          }}
          scroll={tableColumnsLen > 7 ? { x: '140%' } : { x: false }}
        />
        {vehicles && vehicles.length > 0 ? (
          <TablePageSize
            pages={pages}
            changePaginationSize={changePaginationSize}
          />
        ) : null}
      </div>
    );
  }
}

export default withRouter(VehiclesTable);
